import Vue from 'vue'
import Router from 'vue-router'
import childrenPath from './children'
import childrenSys from './childrenSys'
Vue.use(Router)


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const keys = { userInfo: 'userInfo',menu:'lastMenu' }
var router = new Router({
  //mode: 'history',
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/index'),
      redirect: '/Home',
      children:
        [
          ...childrenPath,
          ...childrenSys,
          {
            path: '/Home',
            name: 'HelloWorld',
            component: () => import('@/Home')
          },
          {
            path: '/404',
            name: 'HelloWorld',
            component: () => import('@/NoPage')
          }
        ]
    }, {
      path: '/Login',
      name: 'Login',
      component: () => import('@/login'),

    },{
      path: '/bigData',
      name: 'bigData',
      component: () => import('@/bigData'),

    }
  ]
})

//跳转前拦截处理
router.beforeEach((to, from, next) => {
  if (to.matched.length == 0)
  {
    return next({ path: '/404' });
  }

  if (to.path == "/login") {
    localStorage.removeItem(keys.userInfo);
    localStorage.removeItem(keys.menu);
  }
  
  next();
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js